import { createSlice } from "@reduxjs/toolkit"
import { EMAIL_CONFIG } from "../../../constants/reducer_names"

const initialState = {
    email_config_table_data: [] as any,
    email_config_table_data_store: [] as any,


    emailconfidg_data_update: [] as any,
    get_emailConfig: [] as any,
    isTicketing: [] as any

}

const emailConfigSlice = createSlice({
    name: EMAIL_CONFIG,
    initialState,
    reducers: {
        emailConfigTableData: (state, { payload }) => {
            state.email_config_table_data = payload.email_config_table_data
            state.email_config_table_data_store = payload.email_config_table_data_store
        },

        emailConfigFromTableUpdate: (state, { payload }) => {
            state.emailconfidg_data_update = payload.emailconfidg_data_update
        },
        getAPIemail_config: (state, { payload }) => {
            state.get_emailConfig = payload.get_emailConfig
        },

        setTicketing: (state, { payload }) => {
            console.log('setTicketing---------',payload)
            state.isTicketing = payload.isTicketing
        },
    
        reset: () => { },
    }
})

export const emailConfigSliceActions = emailConfigSlice.actions;
export const emailConfigSliceReducer = emailConfigSlice.reducer;